import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { CustomerTaxExemptionInfo } from '../fragments';

export default gql`
  mutation UpsertCustomerTaxExemption(
    $input: CustomerTaxExemptionUpsertInput!
  ) {
    upsertCustomerTaxExemption(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      customerTaxExemption {
        ...CustomerTaxExemptionInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${CustomerTaxExemptionInfo}
`;
